import { SlideDeck } from '../../lib/slides/types'

export interface SlidesScreenProps {
  presentationURL: string
  selectedSlide: number
  onEndClick(layoutsActive: boolean): void
  onJumpToSlidesClick?(): void
  onNextClick?(object): void
  onPreviousClick?(object): void
  onVideoError(): void
  navigate?(slide: number, step: number): void
  isBridge: boolean
  slideDeck: SlideDeck
  selectedSlideStep: number
  username: null | string
  BTID: string
  presenterLayoutsActive: boolean
}

export interface SlidesScreenCreatorProps extends SlidesScreenProps{
  slidesDeckVersion: string
}

export interface SlidesDeckVersion {
  version: string
}

export interface PresentationObject {
  IsSlideMediaLoaded(slideIndex: number): boolean
  JumpToAnim(stepIndex: number, slideIndex: number, direct: boolean | null): void
  GotoSlide(slideIndex: number): void
  GetContentDetails(): { TotalSlides: number }
  CurrentStatus(): { slide: number, step: number }
  GetCurrentAnimationCount(): number
  ClickCount(): number
  videoStep(): number
  resetSlide( slideIndex: number ): void
}

export interface SlidesScreenState {
  initialised: boolean
  presentation: PresentationObject
  currentSlide: number
  currentStep: number
  frameRef: any
  fullSlidesUrl: string
  isAnimating: boolean
}

export enum SlidesMessage {
  loading = 'loading',
  loadingEnded = 'loadingEnded',
  slideChange = 'slideChange',
  moveToNextAnim = 'moveToNextAnim',
  moveToPrevAnim = 'moveToPrevAnim',
  playingStart = 'playingStart',
  playingEnd = 'playingEnd',
  progressChange = 'progressChange',
  slideEnd = 'slideEnd',
  slideOutlineLoaded = 'slideOutlineLoaded',
  initialised = 'initialised',
  setFrameHeight = 'setFrameHeight',
  videoFailed = 'failedToPlayVideo',
  error = 'error'
}
